import { DateTime } from 'luxon';

export function utcDateTime(date: Date | string) {
  if (typeof date === 'string') {
    return DateTime.fromISO(date, { zone: 'utc' });
  }

  return DateTime.fromJSDate(date, { zone: 'utc' });
}
